<template>
  <div class="contact margin-between-section">
    <div class="row not-margin">
      <div class="col-lg-6 col-md-12 container-info">
        <div class="info">
          <h1>{{ $t('home.contact_title') }}</h1>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 not-padding">
        <div class="info-form-contact">
          <h1>{{ $t('home.contact_txt') }}</h1>
          <div class="con-i" style="white-space:nowrap">
            <input v-model="email" type="text" id="send" :placeholder=" $t('home.form_placeholder') " />

            <button v-on:click="saveMessage" class="btn send-b">{{ $t('home.form_send') }}</button>
            <p class="error" v-if="error != ''" >{{error}}</p>
          </div>
          <p> {{ $t('home.contact_terms') }} <a href="#"> {{ $t('home.contact_label_terms') }} </a>,  <a href="#"> {{ $t('home.contact_label_privacity') }} </a> {{ $t('home.contact_final_place') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Inbox from '../parse/models/Inbox'
import { bus } from "../main";

export default {
  name: 'contact',
  data() {
    return {
      email: "",
      error: ""
    };
  },
  methods: {
    saveMessage(){
      
      if( this.email == ""){
        this.error = this.$t('notification.required')
        return;
      }
      this.notification = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.send_contact')
      }

      this.notificationerror = {
        disable: false,
        sampleMessage: true,
        message: this.$t('notification.error')
      }

      const params = {
        email: this.email,
        lang: localStorage.idiom
      }

      Inbox.saveMessageHome(params)
      .then(user => this.error = this.$t('notification.send_contact'))
      .catch(error => this.error = this.$t('notification.error'))
      
      setTimeout(() => ( this.error = "", this.email = ""), 3000)

    }
  } 
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* -- Error */
.error {
  color: rgb(190, 0, 0) !important;
  margin: 5% auto;
  width: 100%;
  text-align: left;
  font-size: 12px !important;
}


.info{
  text-align: left;
}

.info h1{
  font-size: 25px;
  font-family: 'plain regular', arial
}

.info p{
  padding-top: 5%;
  font-size: 18px;
}

.container-info{
  display: flex;
}


.not-margin{
  margin: 0;
}
.not-padding{
  padding: 0;
}


.info-form-contact{
  text-align: left;
}

.info-form-contact h1{
  font-size: 16px;
  font-family: 'plain regular', arial;
  padding: 0 15px 0 0;
}

.info-form-contact p{
  font-size: 8px;
  margin-top: 15px;
  color: rgb(151, 151, 151);
}

.info-form-contact a{
  font-size: 8px;
  margin-top: 15px;
  color: rgb(116, 116, 116);
  text-decoration: underline;
}


.con-i input{
  border: 0;
  border-bottom: 1px solid #000;
  width: 75%;
  font-size: 12px;
  margin-right: 5%;
  margin-top: 25px;
}

.send-b{
  border: 1px solid #000;
  border-radius: 0;
  margin-left: 0px;
  font-size: 12px;
  padding: 5px 30px;
  margin-bottom: 9px;
}



/* Mobile first queries */

/* Larger than Desktop HD */
@media (max-width: 1200px) {
  .con-i input{
    width: 73%;
  }
}

/* Larger than desktop */
@media (max-width: 992px) {
  .not-padding{
    padding: 15px;
  }

  .info-form-contact h1{
    font-size: 16px;
    margin-top: 15px;
  }

  .con-i input{
    width: 80%;
  }

}

/* Larger than tablet */
@media (max-width: 768px) {

  .con-i input{
    width: 77%;
  }

  .info p{
    font-size: 15px;
    line-height: 22px;
  }
  .not-padding{
    padding: 15px;
  }

  .info-form-contact h1{
    font-size: 15px;
    margin-top: 15px;
    padding: 0;
  }

}

/* Larger than phablet */
@media (max-width: 550px) {
  .info-form-contact h1{
    font-size: 14px;
  }

  .img-about{
    display: none;
  }
  .con-i input{
    width: 72%;
  }
}

/* Larger than mobile */
@media (max-width: 400px) {
  .con-i input{
    width: 70%;
  }
}


</style>
